<template>
  <b-modal
    id="supervisor-reject-modal"
    modal-class="timesheet-modal"
    title="Reject Supervisor Timesheet"
    ok-title="Reject"
    ok-variant="danger"
    :ok-disabled="!rejectForm.reason"
    @ok="$emit('submit', $event)"
    @hidden="$emit('hidden')"
  >
    <b-form-group
      label="Reason"
      description="Why is this timesheet being rejected?"
    >
      <b-form-select
        :value="rejectForm.reason"
        :options="rejectionReasons"
        @input="updateField('reason', $event)"
      />
    </b-form-group>
    <b-form-group label="Comment (optional)">
      <b-form-textarea
        :value="rejectForm.comment"
        placeholder="Additional details for the supervisor..."
        rows="3"
        @input="updateField('comment', $event)"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'SupervisorRejectModal',

  props: {
    rejectForm: {
      type: Object,
      required: true,
    },
    rejectionReasons: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    updateField(key, value) {
      this.$emit('update:rejectForm', { ...this.rejectForm, [key]: value })
    },
  },
}
</script>
